export default __webpack_public_path__ + "static/media/Melania Mazzucco e Simonetta Fiori.c61f7e1e.jpg";